import { ref } from "vue";
import type { Usuario } from "../usuarios";

export const current_user = ref<Usuario | null>(null)